const Pagination = {
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      paginator: {
        nextPage: null,
        prevPage: null,
        count: 0,
      },
    };
  },
  computed: {
    start() {
      return this.currentPage * this.perPage - this.perPage + 1;
    },
    end() {
      let end = this.currentPage * this.perPage;
      return end > parseInt(this.paginator.count) ? this.paginator.count : end;
    },
    total() {
      return Math.ceil(this.paginator.count / this.perPage);
    },
  },
  methods: {
    goToPage(page) {
      this.currentPage = page;
    },
    goToNext() {
      if (this.paginator.nextPage) {
        this.currentPage = this.paginator.nextPage;
      }
    },
    goToPrev() {
      if (this.paginator.prevPage) {
        this.currentPage = this.paginator.prevPage;
      }
    },
    setPerPage(event) {
      this.perPage = event.target.value;
    },
  },
};

export default Pagination;
